import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService, DownloadFile, DownloadFileService, SelectedCustomerService } from 'gung-standard';
import { BehaviorSubject, filter, first, map, Observable, switchMap, of } from 'rxjs';

interface OttoOlsenRowBlockOrder {
  id: string;
  productId: string;
  quantity: number;
  extra: { [s: string]: any };
}

export interface OttoOlsenBlockOrder {
  id: string;
  customerId: string;
  extra: { [s: string]: any };

}

export interface OttoOlsenOrderAgreement{
  id: string;
  deliveryCustomerId: string;
  extra: { [s: string]: any };
  rows: OttoOlsenRowBlockOrder;
}

export interface BlockOrderAgreementSigningRecord {
  id: string;
  vismaSignId?: string;
  status: SigningStatus;
  signingEmails?: string[];
  customerId: string;
}

export enum SigningStatus {
  NEW = "NEW",
  DOCUMENT_CREATED = "DOCUMENT_CREATED",
  FILES_UPLOADED = "FILES_UPLOADED",
  INVITATION_SENT = "INVITATION_SENT",
  SIGNED = "SIGNED",
}



@Injectable({
  providedIn: 'root'
})
export class OttoOlsenBlockOrderAgreementsService {

  constructor(
    protected http: HttpClient, 
    protected authService: AuthService, 
    protected selectedCustomerService: SelectedCustomerService,
    protected downloadFileService: DownloadFileService
  ) {

  }
  customerid: string;
  private blockOrderList: BehaviorSubject<OttoOlsenBlockOrder[]>;

  updateBlockOrderListSubject(customerId: string): void {
    this.getServerBlockOrders(customerId).subscribe(block => {
      this.blockOrderList?.next(block)
    });
  }

  getBlockOrders(customerId = null): Observable<OttoOlsenBlockOrder[]> {
    if (!this.blockOrderList || this.customerid !== customerId) {
      this.blockOrderList = new BehaviorSubject<OttoOlsenBlockOrder[]>(null);
      this.updateBlockOrderListSubject(customerId);
    }
    return this.blockOrderList.asObservable().pipe(filter(blockOrder => !!blockOrder));
  }


  private getServerBlockOrders(customerId: string): Observable<OttoOlsenBlockOrder[]> {
    const url = `json/otto/block-order-agreements`;
    const headers = { maxAge: '-1' };
    if(customerId){
      const urlCustomer = `${url}/for-customer/${customerId}`;
      return this.http.get<OttoOlsenBlockOrder[]>(urlCustomer, { headers });
    }
    return this.authService.getCurrentUser().pipe(first(),
    switchMap(user =>{
      if(user.roles?.includes('ADMIN') || user.extra?.showAllBlockOrders){
        return this.http.get<OttoOlsenBlockOrder[]>(url, { headers });
      }
      return this.selectedCustomerService.getSelectedCustomer().pipe(first(),
        switchMap(customer => {
          const urlCustomer = `${url}/for-customer/${customer.id}`;
          return this.http.get<OttoOlsenBlockOrder[]>(urlCustomer, { headers });
        })
      )
    })
    )
    
  }

  downloadDocument(id): any{
    return this.http.post(`download/otto/generate-block-order-pdf/${id}`, {}, {
      responseType: 'arraybuffer' as 'json', 
      observe: 'response'
    }).pipe(
      map((response: HttpResponse<ArrayBuffer>) => {
        return this.downloadFileService.create(response);
      }),
      map((file: DownloadFile) => {
        return this.downloadFileService.download(file);
      })
    );
  }

  signing(email, id): Observable<any>{
    const url = `json/otto/block-order-agreements/${id}`;
    const payload = {email};
    return this.http.post<any>(url, payload);
  }

  signingStatus(id): Observable<BlockOrderAgreementSigningRecord>{
    const url = `json/otto/block-order-agreements/${id}`;
    return this.http.get<BlockOrderAgreementSigningRecord>(url);
  }

}
